import React from "react";
import { useSelector } from "react-redux";
const Draggable = () => {
  const { reader } = useSelector((state) => state.ui.reader);
  const { topScroll, dragScroll } = reader;

  return (
    <div
      style={{
        position: "fixed",
        top: topScroll - 5,
        cursor: "move",
        background: "transparent",
        height: 37,
        width: "35px",
        left: -5,
        border: "1.5px solid #0A5C59",
        borderRadius: "4px",
        zIndex: 3,
      }}
    >
      {/* child component content */}
    </div>
  );
};
export default Draggable;
